export const ruMessagesCams = {
  linkedAccounts: "Привязанные аккаунты",
  accountAccess: "Доступ к аккаунту",
  exit: "Выход",
  accountRelationsSettings: "Настройка связей учетной записи",
  sortBy: "Сортировать по:",
  language: "Язык",
  languageSelection: "Выбор языка",
  view: "Посмотреть",
  byAddress: "По адресу",
  byHeading: "По заголовку",
  byDateAdded: "По дате добавления",
  user: "Пользователь",
  tile: "Плитка",
  list: "Список",
  cancel: "Отмена",
  save: "Сохранить",
  myCameras: "Мои камеры",
  favorites: "Избранное",
  search: "Поиск",
  showAll: "Показать всё",
  found: "Найдено",
  addresses: "Адреса",
  titles: "Названия",
  noResults: "Нет результатов поиска",
  createFolder: "Создать папку",
  editFolder: "Редактировать папку",
  noCamerasFound: "Камеры не найдены",
  saveSelectedCameras: "Сохранить выбранные камеры",
  enterFolderName: "Введите имя папки",
  folderCreate: "Создание папки",
  saveChanges: "Сохранить изменения",
  createSubfolder: "Создать подпапку",
  deleteFolder: "Удалить папку",
  deleteFolderConfirmation: "Внимание! При удалении папки удалятся все вложенные папки и камеры.",
  folderDeletedSuccess: "Папка {folderName} успешно удалена",
  changesSaved: "Изменения сохранены",
  errorAddingCameras: "Ошибка при добавлении камер",
  errorDeletingFolder: "Ошибка при удалении папки",
  createSubfolderFor: "Создать подпапку для {folderName}",
  cameraDisabled: "Камера отключена",
  cameraNotFound: "Камера не обнаружена",
  embedCamera: "Встроить на сайт",
  cameraSelectedForMonitor: "Камера выбрана для тревожного монитора",
  cameraSelected: "Камера выбрана",
  viewOnline: "Просмотр онлайн",
  viewArchive: "Просмотр архива",
  infoOfCamera: "Информация по камере",
  thermalImager: "Тепловизор",
  carNumberRecognition: "Распознавание номеров",
  faceRecognition: "Распознавание лиц",
  helmetRecognition: "Распознавание касок",
  maskDetector: "Детектор масок",
  perimeterDetector: "Детектор пересечения зоны",
  crowdDetector: "Детектор очереди",
  peopleCounter: "Подсчет посетителей",
  motionAlarm: "Детекция движения",
  parkingDetection: "Детекция парковочных мест",
  player: "Плеер",
  embed: "Встраивание",
  thermalVisionReport: "Отчет по тепловизору",
  carNumberReport: "Отчет по автомобильным номерам",
  faceRecognitionReport: "Отчет по распознаванию лиц",
  helmetReport: "Отчет по каскам",
  maskReport: "Отчет по маскам",
  perimeterReport: "Отчет по вторжению в зону",
  motionAlarmReport: "Отчет по движению",
  parkingDetectionReport: "Отчет по парковкам",
  crowdReport: "Отчет по детекции очереди",
  peopleCountReport: "Отчет по подсчету посетителей",
  onMap: "На карте",
  width: "Ширина",
  height: "Высота",
  fullscreen: "Разворачивать в полный экран",
  autoplay: "Автоматический запуск",
  https: "HTTPS",
  lowLatency: "Прямой эфир без задержки",
  standardPlayback: "Стандартный способ воспроизведения. Видео отдаётся с небольшой задержкой.",
  lowLatencyPlayback: "Видео транслируется без задержек. Не поддерживается в некоторых браузерах.",
  sound: "Звук",
  hoursWithoutReload: "Часов трансляции без перезагрузки:",
  copyCode: "Скопировать код",
  streamError: "Ошибка: не удалось запустить трансляцию",
  copiedToClipboard: "Скопировано в буфер обмена",
  events: "События",
  info: "Информация",
  cameraNumber: "Камера №",
  cameraAddress: "Адрес камеры",
  timezoneOffset: "Часовой пояс",
  invalidDownloadRange: "Невозможно скачать. Выбран некорректный диапазон времени, попробуйте изменить границы скачивания.",
  downloadFailed: "Невозможно скачать. Попробуйте позднее.",
  addCamera: "Добавить камеру",
  alarmCell: "Тревожная ячейка",
  streamUnavailable: "Трансляция недоступна. Необходимо изменить камеру.",
  alarm: "Тревога",
  deleteCamera: "Удалить камеру из ячейки",
  changeCamera: "Изменить камеру в ячейке",
  moveToAnotherCell: "Переместить в другую ячейку",
  selectCameraForCell: "Выберите камеру для ячейки",
  newMosaic: "Новая мозаика",
  enterTitle: "Укажите название",
  addMosaic: "Добавить мозаику",
  hideArchiveTools: "Скрыть инструменты работы с архивом",
  showArchiveTools: "Показать инструменты работы с архивом",
  archive: "Архив",
  cancelChanges: "Отменить все изменения и скрыть настройки",
  showSettings: "Показать настройки текущей мозаики",
  setLowLatency: "Установить для всех камер режим работы без задержки",
  selectAlarmCameras: "Выбрать тревожные камеры для этой мозаики",
  oneCamera: "1 камера",
  fourCamerasGrid: "Сетка на 4 камеры",
  grid5Title: "Сетка 5",
  grid6Title: "Сетка 6",
  grid8Title: "Сетка 8",
  grid9Title: "Сетка 9",
  grid10Title: "Сетка 10",
  grid16Title: "Сетка 16",
  deleteMosaic: "Удалить текущую мозаику",
  delete: "Удалить",
  alarmCameras: "Тревожные камеры",
  public: "Публичные",
  confirmDeleteMosaic: "Хотите удалить эту мозаику?",
  deleteMosaicError: "Ошибка при удалении мозаики",
  deleteMosaicSuccess: "Мозаика удалена",
  saveChangesError: "При сохранении произошла ошибка. Попробуйте перезагрузить страницу и повторите сохранение.",
  saveMosaicError: "При сохранении мозаики произошла ошибка. Попробуйте создать мозаику заново.",
  saveChangesSuccess: "Мозаика сохранена",
  newMosaicAdded: "Добавлена новая мозаика",
  defaultMosaicRedirect: "Мозаика сохранена",
  chooseCamerasForAlarm: "Выберите камеры для получения событий на мозаике",
  setAlarmCameras: "Нажмите 'Сохранить', чтобы активировать выбранные камеры как тревожные",
  setFullscreen: "Установить полноэкранный режим",
  archiveSettings: "Настройки архива",
  hideEventsCount: "Скрыто событий: ",
  hiddenThermalVisionEvents: "Скрыто событий по тепловизору: ",
  hiddenCarNumberEvents: "Скрыто событий по автомобильным номерам: ",
  hiddenFaceRecognitionEvents: "Скрыто событий по распознаванию лиц: ",
  hiddenHelmetEvents: "Скрыто событий по каскам: ",
  hiddenMotionAlarmEvents: "Скрыто событий по движению: ",
  hiddenParkingDetectionEvents: "Скрыто событий по парковкам: ",
  hiddenMaskEvents: "Скрыто событий по маскам: ",
  hiddenCrowdEvents: "Скрыто событий по очереди людей: ",
  hiddenPerimeterEvents: "Скрыто событий по периметру: ",
  hiddenPeopleCounterEvents: "Скрыто событий по подсчету людей: ",
  editTitleTooltip: "Редактировать",
  titleSaveSuccess: "Название камеры успешно изменено",
  titleSaveError: "Ошибка: ",
  titleWarning: "Длина названия не может превышать 64 символа и не может быть пустым",
  noEvents: "События на данном промежутке времени отсутствуют.",
  deleteConfirmation: "Удалить связь с учетной записью?",
  accessHeader: "Доступ к аккаунту",
  nothingHere: "Тут ничего нет",
  createTokenMessage: "Создайте новый токен, для интеграции сторонних систем с нашим сервисом по API",
  createToken: "Создать токен",
  username: "Логин",
  link: "Ссылка",
  token: "Токен",
  copy: "Скопировать",
  deleteToken: "Удалить токен",
  copySuccess: "Скопировано в буфер",
  addLinkPrompt: "Чтобы привязать камеры другой учетной записи нажмите добавить",
  add: "Добавить",
  enterUsername: "Введите логин",
  password: "Введите пароль",
  accountLinkedSuccess: "Учетная запись привязана",
  inputUsernamePassword: "Укажите логин и пароль:",
  employees: "Пользователи",
  accessDevices: "Устройства доступа",
  accessGroups: "Группы доступа",
  cars: "Автомобили",
  searchPlaceholder: "Поиск",
  filterByGroupsPlaceholder: "Фильтр по группам доступа",
  addToGroup: "Добавить в группу",
  removeFromGroup: "Убрать из группы",
  deleteEmployees: "Удалить пользователей",
  addEmployee: "Добавить",
  addEmployeeFromFile: "Добавить из файла",
  downloadReport: "Скачать отчет",
  downloadReportCSV: "Скачать CSV",
  downloadReportXLSX: "Скачать XLSX",
  deleteEmployeeConfirm: "Хотите удалить этого пользователя?",
  deleteEmployeesConfirm: "Хотите удалить выбранных пользователей?",
  employeesDeleted: "Пользователи удалены",
  employeeDeleted: "Пользователь удален",
  errorDeletingEmployee: "Ошибка при удалении пользователя",
  viewAll: "Посмотреть все",
  deleteSelectedEmployeesConfirm: "Хотите удалить выбранных пользователей? Выбрано",
  removeEmployeesFromGroup: "Удалить пользователей из группы",
  addEmployeesToGroup: "Добавить пользователей в группу",
  csvFileName: "Выгрузка по пользователям.csv",
  totalEmployees: "Всего пользователей:",
  tableHeaders: {
    id: "ID",
    name: "Имя",
    cars: "Автомобили",
    deviceAccessGroups: "Группы доступа",
    isActive: "Активен",
    identifier: "Идентификатор",
    emergencyVehicleAccess: "Доступ спецтранспорта",
    cameraCount: "Кол-во камер",
    cameras: "Камеры",
    title: "Название",
    about: "Дополнительное описание",
    employee_count: "Количество пользователей",
    employee_ids: "Пользователи группы",
    expired_date: "Временный доступ",
  },
  entry: "записей",
  employeeName: "Имя пользователя",
  enterEmployeeName: "Укажите ФИО пользователя",
  selectAccessGroups: "Укажите группы доступа и пользователь получит доступ к устройствам",
  carNumbers: "Автомобильные номера",
  accountNumber: "Учетная запись (номер договора)",
  isActive: "Активен?",
  saveAndAddNew: "Сохранить и добавить нового",
  successEmployeeCreated: "Пользователь успешно создан",
  getTemplate: "Получить шаблон",
  successFileUploaded: "Файл успешно загружен",
  errorFileUpload: "Ошибка: ",
  errorLoadEntity: "Ошибка: невозможно отобразить информацию.",
  deviceAccessGroups: "Группы доступа",
  addPhoto: "Добавить фото",
  deletePhoto: "Удалить фото",
  noPhotos: "Фотографий нет",
  attachedUsernames: "Доступ к шлагбауму (номер договора или номер телефона +7)",
  employeeCarsCount: "Количество автомобилей у пользователя: ",
  accessSettings: "Настройки доступа",
  accessGroupList: "Список групп доступа:",
  viewGroup: "Смотреть группу: ",
  confirmDeletePhoto: "Хотите удалить фотографию?",
  errorDeletePhoto: "Ошибка при удалении фото",
  successSave: "Сохранено успешно",
  confirmDeleteEmployee: "Хотите удалить этого пользователя?",
  errorDeleteEmployee: "Ошибка при удалении пользователя",
  addDevice: "Добавить устройство",
  chooseDevice: "Выберите устройство",
  enterEmployee: "Введите пользователя",
  more: "Ещё",
  deviceFilter: "Фильтр по устройствам",
  employeeFilter: "Фильтр по пользователям",
  device: "Устройство",
  employee: "Пользователь",
  accessLevel: "Уровень доступа",
  notFound: "Прав не найдено.",
  foundCount: "Найдено: ",
  addPermissionError: "Ошибка при добавлении прав",
  setPermissionError: "Ошибка при установке прав",
  deletePermissionConfirm: "Хотите удалить эти права?",
  devicePermissionDeleted: "Права на устройство удалены",
  deletePermissionError: "Ошибка при удалении прав",
  fullAccess: "Полный доступ",
  entrance: "Вход",
  selectAccessGroupForDelete: "Выберите группу доступа для удаления из нее пользователей ",
  selectAccessGroupForAdd: "Выберите группу доступа для добавления ее к пользователям ",
  enterAccessGroup: "Введите группу доступа",
  deleteFromGroup: "Удалить из этой группы",
  errorDeleteEmployeesFromGroup: "Ошибка при удалении пользователей из группы. ",
  errorAddEmployeesToGroup: "Ошибка при добавлении пользователей к группе. ",
  noData: "Нет данных",
  totalCount: "Количество",
  selectDevicePlaceholder: "Выберите устройство",
  selectGroupPlaceholder: "Введите название группы доступа",
  addGroup: "Добавить группу пользователей",
  groupFilter: "Фильтр по группам доступа",
  deviceHeader: "Устройство",
  groupHeader: "Группа доступа",
  noPermissions: "Прав не найдено",
  errorAddingPermissions: "Ошибка при добавлении прав",
  errorUpdatingPermissions: "Ошибка при обновлении прав",
  confirmDeletePermission: "Хотите удалить эти права?",
  permissionDeleted: "Права на устройство удалены",
  errorDeletingPermissions: "Ошибка при удалении прав",
  allRowsSelected: "Выбраны все строки",
  selectedRows: "Выбрано строк",
  selectAll: "Выбрать все",
  deviceName: "Название устройства",
  deviceState: "Состояние устройства",
  active: "Активен",
  inactive: "Неактивен",
  emergencyVehicleAccess: "Доступ спецтранспорта",
  available: "Есть",
  notAvailable: "Нет",
  cameraCountForDevice: "Количество привязанных камер к устройству",
  availableCamerasForUser: "Количество доступных камер для текущего пользователя",
  noAvailableCamerasForUser: "У текущего пользователя нет доступных камер.",
  noCamerasAttachedToDevice: "К устройству доступа не привязана ни одна камера.",
  editPermissionsForEmployees: "Изменить права для пользователей",
  editPermissionsForDeviceAccessGroups: "Изменить права для групп доступа",
  editAccessSettings: "Настройки доступа",
  deleteGroups: "Удалить группы",
  createAccessGroup: "Создание группы доступа",
  confirmDeleteGroup: "Хотите удалить эту группу доступа?",
  groupDeleted: "Группа доступа удалена",
  errorDeletingGroup: "Ошибка при удалении группы доступа",
  confirmDeleteGroups: "Хотите удалить выбранные группы доступа? Выбрано {count}",
  groupsDeleted: "Группы доступа удалены",
  errorDeletingGroups: "Ошибка при удалении групп доступа",
  groupTitle: "Название группы доступа",
  groupAbout: "Дополнительное описание",
  employeesCount: "Количество пользователей в группе: ",
  viewAllEmployees: "Посмотреть всех пользователей",
  addEmployeeToGroup: "Добавить пользователя в группу",
  saveSuccess: "Сохранено успешно",
  deleteGroupConfirm: "Хотите удалить эту группу доступа?",
  employeeAddedToGroup: "Пользователь добавлен в группу",
  errorAddingEmployees: "Ошибка при добавлении пользователей к группе.",
  groupName: "Название группы",
  additionalDescription: "Дополнительное описание",
  filterByEmployee: "Фильтр по пользователям",
  deleteCars: "Удалить автомобили",
  addCar: "Добавить автомобиль",
  createCarDialogTitle: "Создание автомобиля",
  confirmDeleteCar: "Хотите удалить этот автомобиль?",
  carDeleted: "Автомобиль удален",
  errorDeleteCar: "Ошибка при удалении автомобиля",
  confirmDeleteSelectedCars: "Хотите удалить выбранные автомобили? Выбрано: {count}",
  carsDeleted: "Автомобили удалены",
  errorDeleteCars: "Ошибка при удалении автомобилей",
  carNumber: "Номер автомобиля",
  carOwner: "Владелец автомобиля",
  existingEmployeeCars: "Существующие автомобили пользователя",
  shownCars: "Показано автомобилей пользователя",
  totalCars: "Всего у него",
  accountLinkedTo: "Учетная запись привязана к",
  deleteAccountLinkConfirmation: "Удалить связь с учетной записью?",
  accessGranted: "Предоставлен доступ",
  name: "Имя",
  number: "Номер",
  access: "Доступ",
  date: "Дата",
  yes: "Да",
  no: "Нет",
  unknown: "Неизвестный",
  startDate: "Дата начала",
  endDate: "Дата конца",
  reset: "Сбросить",
  itemsPerPage: "Элементов на странице",
  screenshot: "Скриншот",
  video: "Видео",
  downloadVideo: "Скачать видео",
  text: "Текст",
  archiveError: "Ошибка: невозможно получить доступ к архиву",
  crowdDetection: "Обнаружение очереди людей",
  screenshotEvent: "Скриншот события",
  eventVideo: "Видео события",
  downloadEventVideo: "Скачать видео события",
  report: "Отчет",
  noHelmet: "Отсутствие каски",
  noMask: "Отсутствие маски",
  duration: "Длительность (в сек.)",
  reportType: "Тип отчета",
  inCount: "Вошло посетителей",
  outCount: "Вышло посетителей",
  defaultReport: "Общий отчет",
  hourly: "Почасовой",
  daily: "По дням",
  weekly: "По неделям",
  monthly: "По месяцам",
  perimeterCrossing: "Вторжение в зону",
  minTemperature: "Наименьшая температура",
  maxTemperature: "Наибольшая температура",
  temperature: "Температура, ℃",
  exceededTemperature: "Температура превышена?",
  maxRowsWarning:
    "Отображается максимально допустимое количество 1000 строк, остальные записи могли быть скрыты. Чтобы увидеть их, уточните фильтры.",
  thermalCameras: "Тепловизоры",
  motions: "Движения",
  helmets: "Каски",
  masks: "Маски",
  crowdGathering: "Детекция очереди",
  zoneCrossing: "Вторжение в зону",
  tooManyRows: "Отображается максимально допустимое количество 1000 строк, остальные записи могли быть скрыты. Чтобы увидеть их, уточните фильтры.",
  eventText: "Событие",
  eventDate: "Дата",
  crowdReportFilename: "Отчет по детекции очереди",
  defaultCrowdEvent: "Детекция очереди",
  helmetReportFilename: "Отчет по каскам",
  helmetMissing: "Отсутствие каски",
  maskReportFilename: "Отчет по маскам",
  perimeterSecurityReportFilename: "Отчет по пересечению периметра",
  unknownEvent: "Неизвестно",
  loadingError: "Произошла ошибка при загрузке данных. Пожалуйста, уточните фильтры.",
  motionReportFilename: "Отчет по движениям",
  thermalReportFilename: "Отчет по тепловизорам",
  title: "Имя",
  tariff: "Тариф",
  address: "Адрес",
  firmwareUpdateMessage: "Прошивка обновляется… не закрывайте и не обновляйте страницу.",
  cameraModel: "Модель камеры",
  macAddress: "MAC-адрес",
  firmwareVersion: "Версия ПО",
  firmwareUpdateAvailable: "Доступно обновление",
  enableVideoStream: "Включить видеопоток",
  enableAudio: "Звук",
  ntpServer: "NTP сервер",
  videoResolution: "Разрешение",
  videoBitrate: "Битрейт",
  nightModeEnable: "ИК подсветка",
  timeZone: "Часовой пояс",
  rebootCamera: "Перезагрузить камеру",
  confirmReboot: "Хотите перезагрузить камеру?",
  cameraRebootIn15Sec: "Камера будет перезагружена в течение 15 секунд",
  configurationError: "Ошибка при конфигурации",
  confirmUpgradeFirmware: "Будет установлена прошивка версии: {version}. Не отключайте камеру от питания и интернета. Это может привести к повреждению.",
  upgradeSuccess: "Прошивка обновится в течение 45 секунд",
  upgradeError: "Произошла ошибка, попробуйте еще раз",
  screenshotAlt: "Скриншот события",
  screenshotProcessing: "Скриншот в обработке.",
  Movement: "Движение",
  continues: "продолжается",
  sec: "сек.",
  deviceId: "Устройство",
  employeeId: "Пользователь",
  specialTransport: "Спецтранспорт",
  eventView: 'Просмотр события',
  downloadError: 'Невозможно скачать. Попробуйте позднее.',
  screenshotView: 'Просмотр скриншота события',
  participants: '&copy; Участники {link}',
  insufficientRights: "Недостаточно прав.",
  liveStreamTokenError: "Не удалось получить токен для доступа к трансляции.",
  archiveTokenError: "Не удалось получить токен для доступа к архиву.",
  multiscreen: "Мультиэкран",
  map: "Карта",
  scud: "СКУД",
  setupCameras: "Настройка камер",
  reloadToUpdate: "Хотите перезагрузить страницу, чтобы обновиться?",
  reloadNow: "Перезагрузить сейчас",
  postpone: "Отложить",
  newVersion: "Вышла новая версия приложения",
  errorWhileLoading: "Ой, при загрузке страницы что-то пошло не так. Давайте попробуем перезагрузить страницу.",
  reload: "Перезагрузить",
  errorOccurred: "Произошла ошибка",
  on: "Включена",
  off: "Отключена",
  auto: "Автоматический режим",
  maxRowLimit: "Превышено максимальное количество строк для экспорта ",
  addUsersToGroup: "Добавить пользователей в группу",
  step1GetTemplate: "Шаг 1: Получить файл шаблон",
  downloadTemplateCSV: "Скачать шаблон CSV",
  downloadTemplateXLSX: "Скачать шаблон XLSX",
  step2ChooseFile: "Шаг 2: Выбрать и загрузить заполненный файл",
  selectFile: "Выбрать файл",
  selectedFile: "Выбран файл",
  uploadFile: "Загрузить файл",
  supportedFormatsHint: "Поддерживаются файлы .xlsx. До 1000 пользователей.",
  usernameHelp: "имя или идентификатор пользователя",
  carNumbersHelp: "автомобильные номера",
  attachedAccountsHelp: "номер договора или телефона (для отображения кнопки открытия шлагбаума в приложении)",
  accessGroupsHelp: "существующие группы доступа (шлагбаумы)",
  startTime: "Время начала",
  endTime: "Время окончания",
  notificationSchedule: "Расписание уведомлений",
  fromSchedule: "C",
  toSchedule: "До",
  addSchedule: "Добавить расписание",
  confirmDeleteSchedule: "Вы уверены что хотите удалить расписание?",
  createSchedule: "Создать расписание",
  editSchedule: "Редактирование",
  selectServicePlaceholder: "Выберите пользователя",
  reasonPlaceholder: "Причина ",
  addBan: "Добавить блокировку",
  noBans: "Не найдено",
  bansAdded: "Запись добавлена",
  confirmDeleteBan: "Вы уверены, что хотите удалить блокировку?",
  banDeleted: "Запись удалена",
  errorDeletingBan: "Ошибка при удалении блокировки",
  barrierOpenError: "Возникла ошибка при открытии шлагбаума. Попробуйте позже",
  deleteCameraConfirmation: "Вы уверены что хотите удалить камеру из папки?",
  noChangesToSave: "Нет изменений для сохранения",
  detectionZone: "Зона детекции",
  viewVideoFromCamera: "Просмотр видео с камеры №{number} - {title}",
  appError: "Упс... Возникли трудности.",
  mobileVersionInDevelopment: "Мобильная версия сайта в разработке.",
  useMobileAppMessage: "Вы можете воспользоваться приложением \"{appName}\", чтобы посмотреть на свои камеры.",
  additionalAccount: "Дополнительный аккаунт",
  accessControl: "Управление доступом",
  videoAnalytics: "Видеоаналитика",
  legacyBrowserWarning: "Вы зашли на сайт через устаревший браузер",
  modernBrowserRecommendation: "Используйте последние версии современных браузеров, например:",
  fallDetectionReport: "Отчет падение человека",
  schedule: "Расписание",
  cameraLabel: "Камера {number}",
  enteredCount: "{count} Вошло",
  exitedCount: "{count} Вышло",
  viewLabel: "Вид:",
  enterDate: "Введите дату",
  invalidDate: "Неверная дата",
  peopleCount: "Количество людей",
  resetPasswordTitle: "При сбросе пароля будет сброшен токен, Вы уверены?",
  passwordAndTokenUpdated: "Пароль и токен обновлены",
  errorResetPassword: "Ошибка сброса пароля",
  confirmDeleteUser: "Вы уверены что хотите удалить пользователя?",
  userDeleted: "Пользователь удален",
  copied: "Скопировано!",
  placeholderEnterTitle: "Введите название",
  addedCamerasCount: "Добавлено камер: {count}",
  selectCameras: "Выберите камеры",
  resetPassword: "Сбросить пароль",
  deleteAccount: "Удалить аккаунт",
  service: "Сервис",
  login: "Логин",
  barrierPromoTitle: "Чтобы подключить дополнительные услуги свяжитесь с контакт-центром",
  freeCallHint: "Бесплатный звонок Мегафон, Билайн, МТС, Yota, Т-Мобайл",
  gotIt: "Понятно",
  endDatePlaceholder: "Дата окончания доступа",
  connectService: "Подключить услугу",
  noAnalyticsCameras: "У Вас нет подключенных камер с аналитикой",
  peopleCounterDesc: "Узнайте сколько человек к вам пришло",
  perimeterSecurityDesc: "Мы оповестим о появлении людей в заданной вами области",
  fallDetectionDesc: "Мы оповестим о падении человека в заданной вами области",
  queueDetectionTitle: "Детекция очереди",
  queueDetectionDesc: "Следите за пополнениями очередей и оповещайте своих сотрудников",
  requestStreamError: "Произошла ошибка. На этой камере невозможно запросить видеопоток.",
  peopleCounterSetupTitle: "Настройка подсчёта посетителей",
  entryPointHint: "Зелёная точка — это точка входа. Система использует её для определения направления движения.",
  controlLineHint: "Красная линия — это контрольная линия, по которой происходит сам подсчёт.",
  important: "Важно:",
  entryPointPlacementHint: "Зелёная точка должна находиться с одной из сторон контрольной линии, но не должна располагаться прямо на линии.",
  entryPointDirectionHint: "Точка входа задаёт, с какой стороны система будет считать, что человек входит.",
  entryMechanismHint: "Если человек двигается от зелёной точки через линию — засчитывается вход. Если в обратную сторону — выход.",
  recognitionThreshold: "Порог распознавания",
  confidenceHint: "Если, уверенность системы в правильном распознавании, ниже этого значения, то событие будет отброшено",
  confidenceCarHint: "Если, уверенность системы в правильном распознавании номера, ниже этого значения, и данного номера нет в компании, то он будет отброшен",
  editRecognitionZone: "Редактировать зону распознавания",
  saveScheduleError: "Ошибка при сохранении расписания",
  setup: "Настройка",
  createAccount: "Создать аккаунт",
  create: "Создать",
  labelTitle: "Название",
  labelService: "Сервис",
  labelLogin: "Логин",
  labelPassword: "Пароль",
  labelToken: "Токен",
  passwordResetWarning: "При сбросе пароля будет сброшен токен, Вы уверены?",
  setupAnalytics: "Настройка аналитик",
  fallDetection: "Падение человека",
  entered: "Вошло",
  exited: "Вышло",
  garbageAccess: "Транспорт в зоне",
  garbageAccessEvent: "Транспорт в зоне",
  garbageAccessReportFilename: "Транспорт в зоне",
  containerMonitoring: "Контроль ТКО",
  containerMonitoringEvent: "Изменение состояния ТКО",
  containerMonitoringReportFilename: "Изменение состояния ТКО",
};
